import React, { useState } from 'react';
import { Button, Form, Input, Modal, notification } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import './SupportWidget.scss';
import { useAuth } from 'shared/contexts/AuthContext';
import API_SERVICE from '../services/api-service';

const initialValues = {
    name: '',
    companyName: '',
    email: '',
    query: '',
};

const SupportWidget: React.FC = () => {
    const { isAuth } = useAuth();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => setIsModalVisible(true);

    const handleClose = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const handleSubmit = async (values: typeof initialValues) => {
        setLoading(true);
        try {
            await API_SERVICE.submitSupportRequest(values);

            notification.success({
                message: 'Support request submitted',
                description: 'Our advisors will be in touch shortly.',
            });
            handleClose();
        } catch (e) {
            notification.error({
                message: 'Unable to submit your request',
                description: API_SERVICE.handleErrors(e),
            });
        } finally {
            setLoading(false);
        }
    };

    if (!isAuth) {
        return null;
    }

    return (
        <>
            <Button
                type="primary"
                size="large"
                shape="round"
                icon={<MessageOutlined />}
                className="support-floating-button"
                onClick={showModal}
            >
                Support
            </Button>
            <Modal
                visible={isModalVisible}
                title="How can we help?"
                onCancel={handleClose}
                className="support-modal"
                wrapClassName="support-modal-wrap"
                zIndex={1060}
                okButtonProps={{ htmlType: 'submit', form: 'support-form', loading }}
                okText="Submit"
                cancelText="Close"
                destroyOnClose
            >
                <Form
                    id="support-form"
                    layout="vertical"
                    form={form}
                    initialValues={initialValues}
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[{ required: true, message: 'Please let us know your name.' }]}
                    >
                        <Input placeholder="Jane Smith" />
                    </Form.Item>
                    <Form.Item
                        label="Company Name"
                        name="companyName"
                        rules={[{ required: true, message: 'Please provide your company name.' }]}
                    >
                        <Input placeholder="Inventya Limited" />
                    </Form.Item>
                    <Form.Item
                        label="Email Address"
                        name="email"
                        rules={[
                            { required: true, message: 'Please share an email we can respond to.' },
                            { type: 'email', message: 'Please enter a valid email address.' },
                        ]}
                    >
                        <Input placeholder="you@company.com" />
                    </Form.Item>
                    <Form.Item
                        label="Query (Help Needed)"
                        name="query"
                        rules={[{ required: true, message: 'Tell us how we can support you.' }]}
                    >
                        <Input.TextArea rows={4} placeholder="Describe what you need help with..." />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default SupportWidget;
